import { render, staticRenderFns } from "./ExtractData.vue?vue&type=template&id=2d03ec9c&"
import script from "./ExtractData.vue?vue&type=script&lang=ts&"
export * from "./ExtractData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports